import React, { useEffect } from 'react'
import InformationModal from './informationmodal/InformationModal'
import ConfirmationModal from './confirmationmodal/ConfirmationModal'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setEDeliveryModalOpen, setEDeliveryRequestedForms, setOpenEDeliveryInfoModal, setSendPdfToPortalConfirmationModal, setSendPdfToPortalCreditCardModal } from '../ManageFederalFormsSlice'
import PaymentDrawer from '../../../../components/paymentdrawer/PaymentDrawer'
import { PLACE_OF_ORIGIN_FOR_PAYMENT, PRICING } from '../../../../components/paymentdrawer/constants'
import ManageFormsService from '../../../../../../services/ManageFormsService'
import { SendPDFToPortal, getFederalGridData } from '../ManageFederalFormsSaga'
import EDeliveryRequestInfoModal from './edeliveryrequestinfomodal/EDeliveryRequestInfoModal'
import { CONSENT_STATUS } from '../../constants'
import Forms from '../../../../../../libs/utility/formsutility/Forms'

const EDeliveryModal = ({ isOpen, onCancelCb, selectedForms = [], payerDetails = {} }) => {

    const dispatch = useDispatch()
    const { sendPdfToPortalConfirmationModal, sendPdfToPortalCreditCardModal, federalStates, paginationState, eDeliveryRequestedForms, openEDeliveryInfoModal } = useSelector(state => state[componentKey])

    useEffect(() => {
        const requestedForms = selectedForms.reduce((acc, form) => {
            if (Forms.getConsentStatusFromID(form?.OptIn) === (CONSENT_STATUS[0] || CONSENT_STATUS[1])) {
                acc.alreadyRequestedForms.push(form);
            } else {
                acc.newlyRequestedForms.push(form);
            }
            return acc;
        }, { alreadyRequestedForms: [], newlyRequestedForms: [] });
        dispatch(setEDeliveryRequestedForms(requestedForms))
    }, [selectedForms])

    return (
        <>
            <InformationModal
                isOpen={isOpen}
                onCancelCb={onCancelCb}
                onSubmitCb={() => {
                    if (eDeliveryRequestedForms?.alreadyRequestedForms?.length) {
                        dispatch(setEDeliveryModalOpen(false))
                        dispatch(setOpenEDeliveryInfoModal(true))
                    } else {
                        dispatch(setEDeliveryModalOpen(false))
                        dispatch(setSendPdfToPortalConfirmationModal(true))
                    }
                }}
            />


            <EDeliveryRequestInfoModal
                isOpen={openEDeliveryInfoModal}
                onCancelCb={() => dispatch(setOpenEDeliveryInfoModal(false))}
                onSubmitCb={() => {
                    dispatch(setEDeliveryModalOpen(false))
                    dispatch(setSendPdfToPortalConfirmationModal(true))
                    dispatch(setOpenEDeliveryInfoModal(false))
                }}
                requestedForms={eDeliveryRequestedForms}
                selectedForms={selectedForms}
            />

            <ConfirmationModal
                isOpen={sendPdfToPortalConfirmationModal}
                onCancelCb={() => {
                    dispatch(setSendPdfToPortalConfirmationModal(false))
                }}
                onSubmitCb={() => {
                    dispatch(setSendPdfToPortalConfirmationModal(false))
                    if (eDeliveryRequestedForms?.newlyRequestedForms?.length) {
                        dispatch(setSendPdfToPortalCreditCardModal(true))
                    }else if(eDeliveryRequestedForms?.alreadyRequestedForms?.length){
                        const data = {
                            AllSelected: false,
                            totalAmount: `${PRICING.STATE_FILING}`,
                            data: eDeliveryRequestedForms?.alreadyRequestedForms?.map(row => {
                                const obj = {};

                                obj.formId = row?.FormId;
                                obj.formTypeId = row?.FormTypeId;
                                obj.formName = row?.FormName;
                                obj.PayeeId = row?.PayeeId ?? "";
                                return obj;
                            }),
                            payerId: payerDetails?.value,
                            payername: payerDetails?.LastName,
                            placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.PDF_PAYMENT,
                            taxYear: federalStates.FederalTaxYear.value,

                            IsPrepaid: true,
                            TotalAmount: `${PRICING.STATE_FILING}`,
                            saveCard: "",
                            isPrepaid: "true",

                            prepayless1: "",
                            prepayFlag: "",

                            IsNoticeChecked: null,
                            isAccountant: "",
                            selectAll: false,

                            payeeCount: "1",
                            SalesTaxAmount: "0",

                            commonisSaveCard: "",
                            CommonSavedCard: "",
                            PaymentEmail: "",
                            CommonBillingaddress: "",
                            CommonCity: "",
                            CommonZipcode: "",
                            CommonState: "",
                            CommonCountry: "",
                            CommonContactEmail: ""
                        }
                        dispatch(SendPDFToPortal(data))
                    }
                }}
            />

            {sendPdfToPortalCreditCardModal &&
                <PaymentDrawer
                    isOpen={sendPdfToPortalCreditCardModal}
                    calculateEstimatedTax={true}
                    onCloseCb={() => {
                        dispatch(setSendPdfToPortalCreditCardModal(false))
                    }}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: Number((Number(eDeliveryRequestedForms?.newlyRequestedForms?.length || 0) * Number(PRICING.E_DELIVERY)).toFixed(2)),
                        FilingFee: Number((Number(eDeliveryRequestedForms?.newlyRequestedForms?.length || 0) * Number(PRICING.E_DELIVERY)).toFixed(2)),
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: eDeliveryRequestedForms?.newlyRequestedForms?.length || 0,
                    }}
                    filingFeeLabel={`eDelivery Fee`}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={ManageFormsService.sendPdfToPortal}
                    onPaymentSuccessCb={() => {
                        if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0) {
                            dispatch(getFederalGridData({ payerId: federalStates.FederalPayer.value, taxYear: federalStates.FederalTaxYear.value, FilterText: paginationState.FilterText, PagFederalPayereNumber: paginationState.PageNumber, PageSize: paginationState.PageSize, IsDesc: paginationState.IsDesc }))
                        }
                    }}
                    placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.PDF_PAYMENT}
                    paymentServiceFunctionExtraParams={{

                        data: eDeliveryRequestedForms?.newlyRequestedForms?.map(row => {
                            const obj = {};

                            obj.formId = row?.FormId;
                            obj.formTypeId = row?.FormTypeId;
                            obj.formName = row?.FormName;
                            obj.PayeeId = row?.PayeeId ?? "";
                            return obj;
                        }),

                        AllSelected: false,
                        totalAmount: `${PRICING.STATE_FILING}`,
                        payerId: payerDetails?.value,
                        payername: payerDetails?.LastName,
                    }}
                />
            }
        </>
    )
}

export default EDeliveryModal
